/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Routes Messages
 *
 * This contains all the text Routes to be displayed on the window's title.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordReset: {
    id: 'passwordReset',
    defaultMessage: 'Password Reset Form',
  },
  activateCitizenAccount: {
    id: 'activateCitizenAccount',
    defaultMessage: 'Activate Citizen Account',
  },
  activateEmail: {
    id: 'activateEmail',
    defaultMessage: 'Activate Email',
  },
  emailPasswordReset: {
    id: 'emailPasswordReset',
    defaultMessage: 'Send Password Reset Email',
  },
  forgotPasswordReset: {
    id: 'forgotPasswordReset',
    defaultMessage: 'Reset Forgot Password',
  },
  forgotUserName: {
    id: 'forgotUserName',
    defaultMessage: 'Forgot UserName Email',
  },
  accountUnlock: {
    id: 'accountUnlock',
    defaultMessage: 'Unlock Account',
  },
  accountUnlockEmail: {
    id: 'accountUnlockEmail',
    defaultMessage: 'Account Unlock Email',
  },
  chapApplication: {
    id: 'chapApplication',
    defaultMessage: 'Chap Application',
  },
  sampleApplication: {
    id: 'sampleApplication',
    defaultMessage: 'Sample of Apply for Benefits',
  },
  sampleApplicationOverview: {
    id: 'sampleApplicationOverview',
    defaultMessage: 'Sample of Apply for Benefits Overview',
  },
  sampleApplicationForm: {
    id: 'sampleApplicationForm',
    defaultMessage: 'Sample of Apply for Benefits Form',
  },
  sampleApplicationConfirmation: {
    id: 'sampleApplicationConfirmation',
    defaultMessage: 'Sample of Apply for Benefits Confirmation',
  },
  submissionFormConfirmation: {
    id: 'Routes_submissionFormConfirmation',
    defaultMessage: 'Submission form confirmation',
  },
  lifeEventsConfirmation: {
    id: 'Routes_lifeEventsConfirmation',
    defaultMessage: 'Change submitted',
  },
  verificationDetails: {
    id: 'Routes_verificationDetails',
    defaultMessage: 'Verification Details',
  },
  footerDisclaimerLabel: {
    id: 'Routes_Disclaimer',
    defaultMessage: 'Disclaimer',
  },
  footerPrivacyLabel: {
    id: 'Routes_Privacy',
    defaultMessage: 'Privacy',
  },
  EmailNotActivatedWarning: {
    id: 'EmailNotActivatedWarning',
    defaultMessage:
      'To activate your email account, please go to "Your Profile" tab above, then click "Validate Email" in the new screen. You will receive an email with a link to validate your email address. If your email has changed, please update the email address by clicking “Edit Email Address” first, then click on "Validate Email".',
  },
  enrollWaitlist: {
    id: 'enrollWaitlist',
    defaultMessage: 'Enroll waitlist',
  },
  applicationForm: {
    id: 'Routes_applicationForm',
    defaultMessage: 'Application form',
  },
});
